import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal__desc"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "modal__desc"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "checkbox-wrapper-2"
}
const _hoisted_8 = {
  for: "isPublic",
  class: "modal__input-checkbox"
}
const _hoisted_9 = {
  key: 3,
  class: "checkbox-wrapper-2"
}
const _hoisted_10 = {
  key: 0,
  for: "isPublic",
  class: "modal__input-checkbox"
}
const _hoisted_11 = {
  key: 1,
  class: "modal__input-checkbox"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_ModalComponent, { modalName: 'isBuildSaveModalVisible' }, {
    title: _withCtx(() => [
      _createTextVNode(" Сохранить сборку ")
    ]),
    body: _withCtx(() => [
      _createVNode(_component_InputComponent, {
        label: 'Название сборки',
        placeholder: 
					_ctx.soldierClass == 'custom' ? `Отряд и особенность` : `Особенность`
				,
        counter: 50,
        required: true,
        onHasErrors: _cache[0] || (_cache[0] = 
					(val) => {
						_ctx.isBtnDisabled = val;
					}
				),
        onOnChange: _cache[1] || (_cache[1] = 
					(val) => {
						_ctx.title = val;
					}
				)
      }, null, 8, ["placeholder"]),
      (_ctx.soldierClass == 'custom')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(" Т.к. это акционный/премиумный отряд, для упрощения поиска, используйте следующую конструкцию: название оружия/отряда и краткое описание, например:"),
            _hoisted_2,
            _createTextVNode("- Винтовка тип 100, японский десант - скорострельность, или"),
            _hoisted_3,
            _createTextVNode("- Sten Mk II(S) инженер быстрый. ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(" Опишите кратко эту сборку, например:"),
            _hoisted_5,
            _createTextVNode("- Быстрый спринтер + бегун, или"),
            _hoisted_6,
            _createTextVNode("- Болтовки - скорострельность. ")
          ])),
      (!_ctx.openedInSingleBuild)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createTextVNode("Видна для всех пользователей: "),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPublic) = $event)),
                class: "sc-gJwTLC ikxBAC"
              }, null, 512), [
                [_vModelCheckbox, _ctx.isPublic]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.item?.data.author == _ctx.user?.uid)
              ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                  _createTextVNode("Видна для всех пользователей: "),
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isPublic) = $event)),
                    class: "sc-gJwTLC ikxBAC"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.isPublic]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, "Сборка будет видна только Вам"))
          ]))
    ]),
    default: _withCtx(() => [
      (!_ctx.openedInSingleBuild)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-m btn-primary modal__confirm",
            disabled: _ctx.isBtnDisabled,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveBuild && _ctx.saveBuild(...args)))
          }, [
            _createTextVNode(" Сохранить ")
          ], 8, _hoisted_12)), [
            [_directive_ripple]
          ])
        : (_ctx.item?.data.author == _ctx.user?.uid)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-m btn-primary modal__confirm",
              disabled: _ctx.isBtnDisabled,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modifyBuild('update')))
            }, [
              _createTextVNode(" Обновить ")
            ], 8, _hoisted_13)), [
              [_directive_ripple]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn-m btn-primary modal__confirm",
              disabled: _ctx.isBtnDisabled,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modifyBuild('new')))
            }, [
              _createTextVNode(" Сохранить для себя ")
            ], 8, _hoisted_14)), [
              [_directive_ripple]
            ])
    ]),
    _: 1
  }))
}